import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { AppBar as MuiAppBar, Drawer as MuiDrawer, Toolbar, CssBaseline, Divider, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Logo from '../Logo';
import {BreadcrumbContext, Breadcrumb} from '../Breadcrumb';
import HelpIcon from '@mui/icons-material/HelpOutline';
import EmailVerificationBanner from '../user/EmailVerificationBanner';
import ThemeModeToggle from '../ThemeModeToggle';

const drawerWidth = 240;
const topBarHeight = 68;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 2),
  minHeight: topBarHeight,
  gap: theme.spacing(1.5),
}));

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  marginLeft: drawerWidth,
  width: `calc(100% - ${drawerWidth}px)`,
  backgroundColor: theme.custom.panel,
  color: theme.custom.text,
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.custom.border}`,
}));

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    boxSizing: 'border-box',
    backgroundColor: theme.custom.panel,
    borderRight: `1px solid ${theme.custom.border}`,
  },
}));

const Layout = ({drawerMenu, toolbarChildren, toolBarMenu, children}) => {
  const { t } = useTranslation();
  const [breadcrumb, setBreadcrumb] = useState([]);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar sx={{ minHeight: `${topBarHeight}px !important`, gap: 2 }}>
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Breadcrumb links={breadcrumb} />
          </Box>
          {toolbarChildren}
          <ThemeModeToggle />
          <Button
            variant="text"
            color="inherit"
            startIcon={<HelpIcon />}
            sx={{ color: (theme) => theme.custom.muted, whiteSpace: 'nowrap' }}
            onClick={() => {
              window.open('https://share.hsforms.com/1y3Wy5mWBTT6PYS3vWoQ74wnw2dx', '_blank');
            }}
          >
            {t('common.support')}
          </Button>
          {toolBarMenu}
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" anchor="left">
        <DrawerHeader>
          <Logo size="26px" />
          <Box component="span" sx={{ fontWeight: 700, fontSize: 15, color: (theme) => theme.custom.text }}>
            VisitorAPI
          </Box>
        </DrawerHeader>
        <Divider sx={{ borderColor: (theme) => theme.custom.border }} />
        {drawerMenu}
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
          minHeight: '100vh',
          backgroundColor: (theme) => theme.custom.pageBg,
        }}
      >
        <Toolbar sx={{ minHeight: `${topBarHeight}px !important` }} />
        <EmailVerificationBanner />
        <Box sx={{ p: { xs: 2, sm: 4 } }}>
          <BreadcrumbContext.Provider value={{ setBreadcrumb }}>
            {children}
          </BreadcrumbContext.Provider>
        </Box>
      </Box>
    </Box>
  );
}

export default Layout;
